module.exports = __webpack_public_path__ + "img/wuhan.2669bae3.jpg";